
export const makeDuckContextFn = () => require.context("../", true, /\.duck\.js$/);
export const makeSagaContextFn = () => require.context("../", true, /\.saga\.js$/);
export const makeContextContextFn = () => require.context("../", true, /\.context\.js$/);
export default {
    makeDuckContextFn,
    makeSagaContextFn,
    makeContextContextFn
};
